import React, { useState } from 'react';
import styled from 'styled-components';
import joinimg from '../../../../images/grouppjimg.png';
import friend_check from '../../../../images/friend_check.png';
import lock from '../../../../images/lock.png';
import Modal from '../../../modal/Modal';
import appInfoContainer from '../../../../auth/appInfoContainer';
import { Link } from 'react-router-dom';

export default function Fitgrouplist({
  setButtonState,
  groupslist,
  setCurrentPostIndex,
  deleteSubmit,
}) {
  const [showModal, setShowModal] = useState(false);
  const [showLock, setShowLock] = useState(false);

  function submitClick() {
    setShowModal(false);
    deleteSubmit();
  }

  return (
    <Fitgrouplistinner>
      {groupslist.map((value) => {
        return (
          <Fitgrouplistpage
            key={`mypage-group-list-item-no-${value['no']}`}
            setShowModal={setShowModal}
            title={value.title}
            num={value.member_num}
            setButtonState={setButtonState}
            // showLock={showLock}
            value={value}
            setCurrentPostIndex={setCurrentPostIndex}
          />
        );
      })}

      <Modal
        setShowModal={setShowModal}
        showModal={showModal}
        title={'모임 탈퇴하기'}
        subtitle={
          '모임을 탈퇴하시면 진행중인 프로젝트가 중단됩니다. 지금 탈퇴하시겠어요?'
        }
        submitClick={submitClick}
      />
    </Fitgrouplistinner>
  );
}

function Fitgrouplistpage(props) {
  const [buttonState, setButtonState] = useState(false);
  function onClick() {
    setButtonState(true);
  }
  function ClickModal() {
    // setButtonState(false);
    props.setShowModal(true);
    props.setCurrentPostIndex(props.value.no);
  }
  return (
    <Grouplistpage setButtonState={setButtonState}>
      <Fitgrouplistzone>
        <Fitgroupimg>
          <Link
            to={`/group/${props.value.no}`}
            style={{ width: '100%', height: '100%' }}
          >
            {props.value.group_cover_img ? (
              <Img
                src={
                  appInfoContainer.imagePath +
                  '/group_cover_img/' +
                  props.value.group_cover_img
                }
              />
            ) : (
              <Img src={joinimg} />
            )}
          </Link>
        </Fitgroupimg>
        <>
          {props.value.visibility == 'private' ? (
            <LockIconinner>
              <LockIcon>
                <img src={lock} />
              </LockIcon>
            </LockIconinner>
          ) : null}
        </>
        <Fitgrouptitle>
          <Fitgrouptit to={`/group/${props.value.no}`}>
            {props.title}
          </Fitgrouptit>
          <Fitgroupnum>{props.num}</Fitgroupnum>
        </Fitgrouptitle>
      </Fitgrouplistzone>
      {/* {
                buttonState == false? 
                <AddFitgroupdButton click={onClick}/>
                : */}
      {props.value.role == 'admin' ? (
        <RemoveFitgroupdButton />
      ) : (
        <RemoveFitgroupdButton click={ClickModal} />
      )}

      {/* } */}
    </Grouplistpage>
  );
}

function AddFitgroupdButton({ click }) {
  return (
    <Button onClick={click}>
      <Plus_icon></Plus_icon>
      <Txt>모임</Txt>
    </Button>
  );
}

function RemoveFitgroupdButton({ click }) {
  return (
    <Button2 onClick={click}>
      <Txt2>모임</Txt2>
      <Check>
        <img src={friend_check}></img>
      </Check>
    </Button2>
  );
}

const Fitgrouplistinner = styled.div`
  padding: calc(100vw * (22 / 375)) calc(100vw * (17 / 375))
    calc(100vw * (11 / 375));
`;

const Grouplistpage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: calc(100vw * (12 / 375));
`;
const Fitgrouplistzone = styled.ul`
  position: relative;
  display: flex;
  align-items: center;
`;
const Fitgroupimg = styled.li`
  display: block;
  width: calc(100vw * (56 / 375));
  height: calc(100vw * (56 / 375));
  overflow: hidden;
  border-radius: 50%;
`;
const Fitgrouptitle = styled.li`
  display: flex;
  align-items: center;
  margin-left: calc(100vw * (11 / 375));
`;
const Fitgrouptit = styled(Link)`
  max-width: calc(100vw * (162 / 375));
  width: auto;
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const Fitgroupnum = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  color: #c6c6c6;
  margin-left: calc(100vw * (5 / 375));
`;

const Button = styled.button`
  width: calc(100vw * (67 / 375));
  height: calc(100vw * (27 / 375));
  border-radius: calc(100vw * (5 / 375));
  border: solid 1px #e6e6e6;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
`;
const Button2 = styled(Button)`
  background-color: #4e4e4e;
`;

const Txt = styled.span`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  color: #4e4e4e;
`;
const Txt2 = styled(Txt)`
  color: #fff;
`;

const Check = styled.p`
  width: calc(100vw * (10.2 / 375));
  height: calc(100vw * (7.9 / 375));
  margin-left: calc(100vw * (3 / 375));
`;
const Plus_icon = styled.span`
  position: relative;
  display: block;
  width: calc(100vw * (8 / 375));
  height: calc(100vw * (1.3 / 375));
  background: #4e4e4e;
  margin-right: calc(100vw * (3 / 375));

  &::after {
    content: '';
    position: absolute;
    display: block;
    width: calc(100vw * (8 / 375));
    height: calc(100vw * (1.3 / 375));
    background: #4e4e4e;
    transform: rotate(90deg);
  }
`;
const LockIconinner = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100vw * (24 / 375));
  height: calc(100vw * (24 / 375));
  background-color: #4e4e4e;
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  left: calc(100vw * (36 / 375));
`;
const LockIcon = styled.span`
  display: block;
  width: calc(100vw * (11 / 375));
  height: calc(100vw * (15 / 375));
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
